import {Component} from '@angular/core';
import {LogoutApiService} from "../../services/apis/auth/logout/logout-api.service";
import {ApiResponse} from "../../services/apis/dtos/api-response";
import {ErrorResponse} from "../../services/apis/dtos/error-response";
import {NzMessageService} from "ng-zorro-antd/message";
import {AppRoutes} from "../../routes/app-routes";
import {Router} from "@angular/router";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})

export class FooterComponent {
  currentYear: number;

  constructor(private readonly logoutApiService: LogoutApiService, private readonly message: NzMessageService, private readonly router: Router) {
    this.currentYear = new Date().getFullYear();
  }

  onLogoutClick() {
    this.logoutApiService.logout().subscribe({
      next: (response: ApiResponse) => {
        if (response.status === 'success') {
          this.message.success('خارج شدید');
          this.router.navigate([AppRoutes.AUTH.LOGIN]).then(() => {
            window.location.reload();
          });
        }
      },
      error: (error: ErrorResponse) => {
        if (error.status === 'error') {
          error.data.message.forEach(msg => {
            this.message.error(msg);
          });
        }
      }
    });

  }
}
